<div class="th-menulevel">
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(menus.Done)">
    <span>{{ 'menus.actionPlanDone' | translate }}</span>
  </div>
  <!-- <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(menus.Collaborate)">
    <span>{{ 'menus.actionPlanCollaborate' | translate  }}</span>
  </div> -->
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(menus.CreateReport)">
    <span>{{ 'menus.actionPlanCreateReport' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(menus.Reports)">
    <span>{{ 'menus.actionPlanReports' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(menus.Inspection)">
    <span>{{ 'menus.open-inspection' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(menus.ChangeInputLanguage)">
    <span>{{ 'menus.inputLanguage' | translate }}</span>
  </div>
</div>
